import { Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'saMatSelectToolTipVisible',
    pure: false
})
export class MatSelectToolTipVisiblePipe implements PipeTransform {
  constructor() {
  }

  transform($element: any): any {
        if ($element.viewValue == '') {
            return true;
        }
        const element = $element._element.nativeElement;
        if (!element || !element.parentElement) {
            return true;
        }

        const childElements = element.getElementsByClassName('mat-option-text');

        if (!childElements || childElements.length == 0) {
            return true;
        }

        const parentWidth = element.parentElement.scrollWidth;
        const result =  childElements[0].scrollWidth < parentWidth;
        return result;
  }
}
